<template>
  <div v-if="visiable" class="tz-dialog">
    <div
      class="dlg-line"
      v-html="seachKeyword(msg, '一次性答完', '不可中途关闭答题页面')"
    ></div>
    <div>
      <b-button @click="cancel">取消</b-button>
      <b-button @click="confirm">确认</b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    visiable: {
      type: Boolean,
      default: true,
    },
    ok: {
      type: Boolean,
      default: false,
    },
    msg: {
      type: String,
      default: "",
    },
  },
  methods: {
    cancel() {
      this.$router.back();
    },
    confirm() {
      this.$emit("update:ok", true);
    },
    seachKeyword(val, keyword1, keyword2) {
      val += "";
      if (val.indexOf(keyword1) != -1 && keyword1) {
        val = val.replace(
          keyword1,
          `<span style='color:red;'>${keyword1}</span>`
        );
      }
      if (val.indexOf(keyword2) != -1 && keyword2) {
        val = val.replace(
          keyword2,
          `<span style='color:red;'>${keyword2}</span>`
        );
      }
      return val;
    },
  },
};
</script>
<style scoped>
.tz-dialog {
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  font-size: 200%;
  font-weight: bold;
}
.dlg-line {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/dialog/confirmdialog.vue